import { Component } from "@angular/core";
import { TimerTableColumn } from "../custom-table-column/timer-table-column";
import { CustomTableValueComponent } from "./abstract-custom-table-value.component";

@Component({
    selector: 'timer-table-value',
    template: '<timer [startTimestamp]="element[column.path]" [endTimestamp]="element[column.endTimestampPath]"></timer>'
})
export class TimerTableValueComponent extends CustomTableValueComponent<TimerTableColumn> {
}